export enum AuthActionType {
    USER_LOGGED_IN = 'USER_LOGGED_IN',
    USER_LOGGED_OUT = 'USER_LOGGED_OUT',
    USER_LOGIN_FAILED = 'USER_LOGIN_FAILED',
    SET_APP_CONTEXT = 'SET_APP_CONTEXT'
}